<template>
    <div class="detail-item flex flex-row w-full">
        <div class="flex items-start mr-3">
            <i :class="['icon text-slate-400', icon]"></i>
        </div>
        <div class="flex items-start flex-col min-w-0">
            <label
                class="text-sm text-slate-400"
                v-text="label"
            ></label>
            <div class="detail-item-body text-slate-600 break-words max-w-full text-slate-600">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CompanyShowDetailItem',
    props: {
        label: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.detail-item-body {
    a {
        @apply text-blue-600;
    }
}
</style>
